<!-- List View -->
<div class="cd-section" id="regulations" style="background-color: white; padding-top: 100px" *ngIf="strView == 'list'">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="text-center">
                    <h1>Other Downloads <span class="badge badge-pill badge-info align-top" style="font-size: .5em;">{{ downloads.length }}</span></h1>
                    <h5>Our platform provides the ability to import and export multiple types of content that can be shared between RegScale customers. The current list of downloadable content is shown in the table below: </h5>
                    <div class="input-group mt-4">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="basic-addon1"><i class="fas fa-search"></i></span>
                        </div>
                        <input type="text" class="form-control" placeholder="Search" [(ngModel)]="strSearch" aria-label="search" name="search" aria-describedby="basic-addon1" (keyup.enter)="filter()">
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <table class="table m-4">
                    <thead>
                        <tr>
                            <th style="font-weight: bold;">Title</th>
                            <th style="font-weight: bold;">Description</th>
                            <th style="font-weight: bold;">Category</th>
                            <th style="font-weight: bold;">Download</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of filtered">
                            <td>
                                {{ r.title }}
                            </td>
                            <td>
                                {{ r.description }} 
                            </td>
                            <td>
                                {{ r.category }}
                            </td>
                            <td>
                                <button class="btn btn-success mr-3" download (click)="load(r)" title="Download this piece of RegScale content"><i class="fas fa-download mr-1"></i>Download
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>

<!-- Download View -->
<div class="cd-section" id="regulations" style="background-color: white; padding-top: 100px" *ngIf="strView == 'download'">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <a style="color: gray;" (click)="back()"><i class="fas fa-arrow-left ml-2"></i> Back</a>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8 offset-md-2">
                <div class="text-center">
                    <h1><i class="fas fa-download"></i> Download</h1>
                    <h5>Below are multiple options for conveniently downloading the selected item: </h5>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card" style="width: 100%;">
                    <div class="card-header">
                      <h3 style="font-weight: bold !important;">{{ selected.value }}</h3>
                    </div>
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item" style="margin-bottom: 35px; margin-top: 35px;"><span style="font-weight: bold;">Curl:</span> <span style="color: #1a70ad">{{selected.curl }}</span> <i class="far fa-copy ml-2" (click)="copy(selected.curl)"
                            title="Click to copy to your clipboard."></i></li>
                      <li class="list-group-item" style="margin-bottom: 35px;"><span style="font-weight: bold;">PowerShell:</span> <span style="color: #1a70ad">{{selected.powershell }}</span> <i class="far fa-copy ml-2" (click)="copy(selected.powershell)"
                        title="Click to copy to your clipboard."></i></li>
                    </ul>
                  </div>
            </div>
        </div>
    </div>
</div>


